import { IPromotionsDetailsProps } from './PromotionsDetails.types'
import {
  BuyLabel,
  DiscountLabel,
  PromotionsDetailsCell,
  PromotionsDetailsRow,
  PromotionsDetailsWrapper,
  SavingLabel
} from './PromotionsDetails.styles'
import { isString } from '../../../utils'
import useId from '../../hooks/useId'

const PromotionsDetails = ({
  details,
  styles,
  'data-testid': testid = 'promotion-detail',
  ...props
}: IPromotionsDetailsProps) => {
  const { getTestId } = useId(testid)
  return (
    <PromotionsDetailsWrapper sx={styles} data-testid={getTestId()} {...props}>
      {details.map(({ text, secondaryText, tertiaryText, id }) => {
        const textProps = isString(text) ? { value: text } : text
        const secondaryTextProps = isString(secondaryText)
          ? { value: secondaryText }
          : secondaryText
        const tertiaryTextProps = isString(tertiaryText)
          ? { value: tertiaryText }
          : tertiaryText

        return (
          <PromotionsDetailsRow key={id}>
            <PromotionsDetailsCell>
              <BuyLabel {...textProps} />
              <DiscountLabel {...secondaryTextProps} />
            </PromotionsDetailsCell>
            <PromotionsDetailsCell>
              <SavingLabel {...tertiaryTextProps} />
            </PromotionsDetailsCell>
          </PromotionsDetailsRow>
        )
      })}
    </PromotionsDetailsWrapper>
  )
}

export default PromotionsDetails
